module.exports = __webpack_public_path__ + "static/media/konjo-ai-sparkles.28668c7c.svg";